import { homepage2Url, homepageUrl } from 'mk2/apps/home/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [{
    app: 'home',
    exact: true,
    path: homepageUrl,
    getPage: () => {
        return import('mk2/apps/home/containers/Home/HomePage' /* webpackChunkName: "home.Home" */);
    },
    modules: [ 'mk2/apps/home/containers/Home/HomePage' ],
}, {
    app: 'home',
    exact: true,
    path: homepage2Url,
    getPage: () => {
        return import('mk2/apps/home/containers/Home2/Home2Page' /* webpackChunkName: "home.Home2" */);
    },
    modules: [ 'mk2/apps/home/containers/Home2/Home2Page' ],
}];
